import { Link } from "react-router-dom";
import useAdminAnalyticsQuery from "../../../hooks/queries/useAdminAnalyticsQuery";
import useDelayedFlag from "../../../hooks/useDelayedFlag";
import KpiCard from "../../../components/analytics/KpiCard";
import TrendChart from "../../../components/analytics/TrendChart";
import SourceBreakdownChart from "../../../components/analytics/SourceBreakdownChart";
import CustomersTable from "../../../components/analytics/CustomersTable";
import AnalyticsSkeleton from "../../../components/analytics/AnalyticsSkeleton";
import { formatCurrency, formatNumber } from "../../../components/analytics/analyticsFormat";
import "../../../styles/components/analytics.scss";

// 0025: dedicated org-wide analytics PAGE for Admin (reached via the dashboard nav card,
// behind AdminRoute). Reuses the unchanged 0024 RQ hook + endpoints. ₪ figures are site
// order totals (ex-VAT), not invoices.
const AdminAnalyticsPageComponent = () => {
  const { data, isLoading, isError } = useAdminAnalyticsQuery();
  const showSkeleton = useDelayedFlag(isLoading);

  return (
    <div className="analyticsPage" dir="rtl">
      <div className="analyticsPageHeader">
        <Link to=".." className="analyticsBackLink">
          <i className="fa-solid fa-arrow-right"></i> חזרה לאיזור הניהול
        </Link>
        <h1 className="analyticsPageTitle">סקירת פעילות</h1>
        <p className="analyticsPageSubtitle">
          מבוסס על הזמנות שבוצעו באתר (מחזור לפני מע״מ) — נתוני האתר, לא נתוני הנהלת חשבונות
        </p>
      </div>

      {isLoading ? (
        showSkeleton && <AnalyticsSkeleton />
      ) : isError || !data ? (
        <p className="analyticsEmpty">לא ניתן לטעון נתונים כרגע</p>
      ) : (
        <>
          <div className="analyticsKpiGrid">
            <KpiCard
              tone="green"
              label="מחזור החודש (לפני מע״מ)"
              value={formatCurrency(data.kpis.revenueThisMonth)}
              icon="fa-solid fa-shekel-sign"
            />
            <KpiCard
              tone="blue"
              label="הזמנות החודש"
              value={formatNumber(data.kpis.ordersThisMonth)}
              icon="fa-solid fa-shopping-bag"
            />
            <KpiCard
              tone="blue"
              label="ערך הזמנה ממוצע"
              value={formatCurrency(data.averageOrderValue)}
              icon="fa-solid fa-receipt"
            />
            <KpiCard
              tone="green"
              label="לקוחות פעילים (30 יום)"
              value={formatNumber(data.kpis.activeCustomers)}
              icon="fa-solid fa-users"
            />
            <KpiCard
              tone="green"
              label="סוכנים פעילים (30 יום)"
              value={formatNumber(data.activeAgents)}
              icon="fa-solid fa-user-tie"
            />
          </div>

          <TrendChart data={data.trend} />

          <div className="analyticsTwoCol">
            <SourceBreakdownChart data={data.ordersBySource} />
            <CustomersTable title="לקוחות מובילים לפי מחזור" rows={data.topCustomers} accent="green" />
          </div>
        </>
      )}
    </div>
  );
};

export default AdminAnalyticsPageComponent;
